import React from 'react';
import clsx from 'clsx';

// import { LessonType } from '../../useCourse';
import { LessonType } from '../../api';
import { formatSeconds } from '../../utilities';
import { Checkmark } from '../../assets/icons/Checkmark';
import { Exam, PlayCircle, TrafficCone } from '../../assets/icons';

type LessonVideoProps = {
  number: number;

  lesson: LessonType;
  active: boolean;
  completed: boolean;
};

const stepType = new Map([
  ['VIDEO', <PlayCircle />],
  ['QUIZ', <Exam />],
  ['PRACTICE', <TrafficCone />],
]);

export const LessonComponent: React.FC<LessonVideoProps> = ({
  lesson,
  completed,
}) => {
  return (
    <div className="flex">
      <div className="shrink-0 w-[1.5rem] flex justify-end pr-[0.6rem]">
        {completed && (
          <span className="text-completed">
            <Checkmark />
          </span>
        )}
      </div>
      <div>
        <div className="flex shrink-1">
          <div className={clsx('text-small font-medium leading-[2.4rem]')}>
            {lesson.title}
          </div>
        </div>
        <div className="flex items-center">
          {lesson?.type && (
            <span className="opacity-65">{stepType.get(lesson?.type)}</span>
          )}
          <div className="text-tiny font-normal">
            {lesson?.type === 'VIDEO'
              ? formatSeconds(lesson.durationMinutes)
              : lesson?.type === 'QUIZ'
                ? 'Quiz'
                : 'Practice'}
          </div>
        </div>
      </div>
    </div>
  );
};
